// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
<div style="height: 100%">
  <v-toolbar dark dense class="obspanel-toolbar">
    <v-btn icon to="/p/users/signin">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
  </v-toolbar>

  <v-container fluid style="height: 100%">
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="text-h5 mb-0">Thanks for Signin In to NoctuaSky.com!</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <p>Before you can continue, you need to confirm that your email is valid.</p>
        <p>We have just sent you a message containing a confirmation link that you need to click.</p>
      </v-card-text>
    </v-card>
  </v-container>

</div>
</template>

<script>

export default {
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
